const updated = () => {
  console.log('New content is downloading.');
};

const register = async (path) => {
  const registration = await navigator.serviceWorker.register(path);
  console.log('Service worker has been registered.');
  const cacheList = await caches.keys();
  cacheList.forEach(async (cacheName) => {
    if (!cacheName.includes('-temp')) { return; }
    const tempCache = await caches.open(cacheName);
    const tempCacheKeys = await tempCache.keys();
    if (tempCacheKeys.length > 0) {
      updated();
    }
  });
  registration.onupdatefound = () => updated();
};
if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    register(`${process.env.BASE_URL}service-worker.js`);
  }
}
